var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
/**
 * Product Base Class
 *
 * This is the base class that all products will inherit
 *
 * @class OCS.Product.Base
 * @constructor
 * @requires moolite 1.0.1+, OCS.UniqueIdGen
 * @type Class
 *
 */

OCS.Product = OCS.Product || {};
OCS.Product.Base = new Class({
    Implements: [Options, Events],
    debug: false,
    container: null, // The selector for the container
    options: {
        initial_url_ops: null,
        product_class_name: 'Base',
        event_namespace: '.product',
        product_unique_id: '',
        properties: [],
        product_container_prefix: 'map_'
    },
    initialize: function (container, op) {
        this.setOptions(op);
        if (container) {
            this.set_container(container);
        }
        this.register_all_events();
        this.init_ajax();
        this.get_product_unique_id();
    },
    register_all_events: function () {

    },
    remove_all_events: function () {

    },
    init_ajax: function () {

    },
    get_event_namespace: function () {
        return this.options.event_namespace + "." + this.options.product_class_name + "." + this.options.product_unique_id;
    },
    set_container: function (container) {
        this.container = container;
    },
    render: function () {

    },
    resize: function () {

    },
    destroy: function () {
        this.container = null;
        this.remove_all_events();
        this.options = {
            initial_url_ops: null,
            product_class_name: 'Base',
            event_namespace: '.product',
            product_unique_id: '',
            properties: [],
            product_container_prefix: 'map_'
        };
    },
    update_product_options: function (product_meta_info) {
        this.initial_url_ops = product_meta_info;
    },
    get_product_unique_id: function () {
        if (this.options.product_unique_id === '') {
            this.options.product_unique_id = this.create_unique_id();
        }
        return this.options.product_unique_id;
    },
    getCacheBustedUrl: function(url, cache_buster) {
        var url_obj = new URI(url);
        url_obj.setData({'cache_bust': cache_buster}, true);
        return url_obj.toString();
    },
    create_unique_id: function () {
        var id_gen;

        if (OCS.Classes.UniqueIdGen) {
            id_gen = new OCS.Classes.UniqueIdGen({unique_id_prepend_string: this.options.product_class_name + "_"});
        } else {
            id_gen = new OCS.UniqueIdGen({unique_id_prepend_string: this.options.product_class_name + "_"});
        }

        return id_gen.create_unique_id();
    },

});